// Section 17: Equal shares. Everyone gets stock / demand of their need (after pins).
// Strength falls for everyone; no trust penalty for unfairness.
import { applyPins, equalFill, flattenRanked } from '../../core/allocation';
import { defineRationPolicy } from '../../core/registry';
import type { Config } from '../../config';

export function equal(_config: Config) {
  return defineRationPolicy({
    id: 'equal',
    label: 'Equal shares',
    section: 'S17',
    allocate(_ctx, input) {
      const order = flattenRanked(input.ranked);
      const fill = applyPins(order, input.demand, input.available, input.pinned);
      equalFill(
        order.filter((id) => input.pinned[id] === undefined),
        input.demand,
        fill,
      );
      return { shares: fill.shares, order };
    },
  });
}
